import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import useMarket from 'hook/useMarket'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toggleModalZoom } from 'store/actionReducers/ModalCommonStore'
import iconZoom from '../../../../assets/images/Home/icon-zoom.png'
import './MarketReview.scss'
import { options } from './MarketReview1Config'

export default function MarketReview1() {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({ time: '6M' })
  const CommnonStore = useSelector(state => state?.CommnonStore)
  const MarketStore = useSelector(state => state?.MarketStore)
  const { fetchVietnam, filterVietname } = useMarket();

  let height = 250;
  let fontSizeLabel = '14px'
  if (CommnonStore?.innerWidthScreen < 1440 && CommnonStore?.innerWidthScreen > 700) {
    height = 250
  } else if (CommnonStore?.innerWidthScreen < 700) {
    height = 200;
    fontSizeLabel = '10px'
  }

  const handleZoomModal = (type) => {
    dispatch(toggleModalZoom(type))
  }

  const handleFilter = (value) => {
    fetchVietnam({ time: value })
    setFilter({ time: value })
  }

  return (
    <>
      <div className='xlwouocrlq'>
        <div className='czmxzggkie'>Định giá các thị trường</div>
      </div>
      <div className='ozbfgukqye'>
        <div className='awwxanjhdo' style={{ marginBottom: 0 }}>
          <div className='fskaneywbs'>
          </div>
          <div className='gxrkqvwmpi'>
            Định giá (P/E) TTCK Việt Nam
          </div>
        </div>
        <div className='awwxanjhdo'>
          <div className='fskaneywbs'>
            <div onClick={() => handleFilter('6M')} className={`bifgkqkhej ${filter?.time === '6M' ? 'mrpddsvjim' : ''}`}>6M</div>
            <div onClick={() => handleFilter('1Y')} className={`bifgkqkhej ${filter?.time === '1Y' ? 'mrpddsvjim' : ''}`}>1Y</div>
            <div onClick={() => handleFilter('2Y')} className={`bifgkqkhej ${filter?.time === '2Y' ? 'mrpddsvjim' : ''}`}>2Y</div>
          </div>
          <div className='gxrkqvwmpi'>
          </div>
        </div>
        <div className='rvwpnmqluj'>
          <HighchartsReact
            highcharts={Highcharts}
            options={options(filterVietname(MarketStore?.marketVietnam || []), filter.time, height, fontSizeLabel)}
          />
          <div className="laAwQBVfKg">
            VN Index
          </div>
          <div className="BMSsrhECYA">
            P/E
          </div>
          <div className='kZHMiIteba' onClick={() => handleZoomModal('MarketReview1')}><img src={iconZoom} alt="" className="rpXAPQTJxi" /></div>
          <div className='rzuxgkjhyu' style={{ margin: '12px auto'}}>
            <div className={`tivnwxskuv`} onClick={() => console.log('VN Index')}>
              <div className='tpbrgdqbkx' style={1 - 1 ? { backgroundColor: '#22AB24' } : { border: '2px solid #22AB24' }}></div>VN Index</div>
            <div className={`tivnwxskuv`} onClick={() => console.log('P/E')}>
              <div className='tpbrgdqbkx' style={1 - 1 ? { backgroundColor: '#f7931a' } : { border: '2px solid #f7931a' }}></div>P/E</div>
          </div>
        </div>
      </div>
    </>
  )
}